
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index3itlED1HklMeta } from "/nuxt-app/pages/about-the-project/index.vue?macro=true";
import { default as index5DkwA8n119Meta } from "/nuxt-app/pages/contacts/index.vue?macro=true";
import { default as indexgC0f606a4hMeta } from "/nuxt-app/pages/documents/index.vue?macro=true";
import { default as clinicKKkw2ZYJtMMeta } from "/nuxt-app/pages/index/clinic.vue?macro=true";
import { default as doctorKeG0EJ5VwDMeta } from "/nuxt-app/pages/index/doctor.vue?macro=true";
import { default as indexYN3Ovpu6SXMeta } from "/nuxt-app/pages/index/index.vue?macro=true";
import { default as indexPzsWdblndXMeta } from "/nuxt-app/pages/index.vue?macro=true";
import { default as indexyXEUgP9XeLMeta } from "/nuxt-app/pages/license-agreement/index.vue?macro=true";
import { default as indexyg30wYvE6aMeta } from "/nuxt-app/pages/privacy-policy/index.vue?macro=true";
import { default as indexpSyuOKBGcRMeta } from "/nuxt-app/pages/public-offer/index.vue?macro=true";
import { default as indexV9qN3jl6lZMeta } from "/nuxt-app/pages/redirect/index.vue?macro=true";
import { default as indexEcZAXG6qPwMeta } from "/nuxt-app/pages/terms-of-use/index.vue?macro=true";
export default [
  {
    name: "about-the-project",
    path: "/about-the-project",
    meta: index3itlED1HklMeta || {},
    component: () => import("/nuxt-app/pages/about-the-project/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    meta: index5DkwA8n119Meta || {},
    component: () => import("/nuxt-app/pages/contacts/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexgC0f606a4hMeta || {},
    component: () => import("/nuxt-app/pages/documents/index.vue")
  },
  {
    name: indexPzsWdblndXMeta?.name,
    path: "/",
    component: () => import("/nuxt-app/pages/index.vue"),
    children: [
  {
    name: "index-clinic",
    path: "clinic",
    meta: clinicKKkw2ZYJtMMeta || {},
    component: () => import("/nuxt-app/pages/index/clinic.vue")
  },
  {
    name: "index-doctor",
    path: "doctor",
    component: () => import("/nuxt-app/pages/index/doctor.vue")
  },
  {
    name: "index",
    path: "",
    component: () => import("/nuxt-app/pages/index/index.vue")
  }
]
  },
  {
    name: "license-agreement",
    path: "/license-agreement",
    meta: indexyXEUgP9XeLMeta || {},
    component: () => import("/nuxt-app/pages/license-agreement/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexyg30wYvE6aMeta || {},
    component: () => import("/nuxt-app/pages/privacy-policy/index.vue")
  },
  {
    name: "public-offer",
    path: "/public-offer",
    meta: indexpSyuOKBGcRMeta || {},
    component: () => import("/nuxt-app/pages/public-offer/index.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    meta: indexV9qN3jl6lZMeta || {},
    component: () => import("/nuxt-app/pages/redirect/index.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    meta: indexEcZAXG6qPwMeta || {},
    component: () => import("/nuxt-app/pages/terms-of-use/index.vue")
  }
]